import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { array, func, string } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import CartaoCredito from '../../../../components/CartaoCredito/CartaoCredito'
import InlineLoader from '../../../../components/InlineLoader/InlineLoader'
import CVVInput from '../../../../components/CVVInput/CVVInput'
import ValorTotalOpcional from './ValorTotalOpcional'
import BotaoOpcionais from './BotaoOpcionais'
import { useOpcionais } from '../../../../contexts/OpcionaisContext'
import { BOTOES_CARTAO, CANCELAR, CONFIRMAR, INFO_COMPRA_CARTAO_MODAL } from '../../constantsCardOpcionais'
import { isEmptyObject } from '../../../../utils/helpers/helpers'
import {
  METODO_PAGAMENTO_CARTAO,
  MODALIDADE_CURADORIA,
  MODALIDADE_INEDITOS
} from '../../../../constants'
import { navigate } from '@reach/router'

const EstiloOpcionalCartao = styled.div`
  .campo-cvv {
    width: 100%;
  }
  .bold {
    font-weight: 600;
  }

  .botao-opcionais {
    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      margin-top: 15px;
      button {
        margin-right: 10px;
      }
    }
  }
  h3 {
    color: #110e22;
    font-size: 18px;
    line-height: 20px;
  }
`

const Wrapper = styled.div`
  @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
    padding-bottom: 20px;
  }
  .cartao__bandeira {
    width: 39px;
    height: 27px;
  }
  p {
    letter-spacing: 0.4px;
    font-weight: 600;
    color: #343a4f;
  }

  .campo-cvv {
    height: 50px;
    width: 50%;
    @media (max-width: 500px) {
      width: 75%;
    }
    @media (max-width: 300px) {
      width: 100%;
    }
  }
  .cvv-opcionais {
    p {
      line-height: 25px;
    }
  }
  .valor-opcionais {
    color: #343a4f;
    font-weight: 600;
    font-size: 22px;
    line-height: 26px;
  }
`
const Pmessage = styled.p`
  color: #4e5464;
  line-height: 20px;
  span {
    font-weight: 700;
    cursor: pointer;
    color: #21c5e5;
    text-decoration: underline;
  }
`

const OpcionaisPagamentoCartao = ( { fecharModal, modalidadesDaAssinatura } ) => {
  const {
    comprarOpcional,
    dadosOpcionais,
    infoPagamento,
    loadingOpcionais,
    modalidadesEscolhidaOpcionais,
    setOpcionalSelecionado,
    opcionaisSelecionados,
    setInfoPagamento
  } = useOpcionais()
  const [ dadosCartao, setDadosCartao ] = useState( [] )

  useEffect( () => {
    if (
      !isEmptyObject( dadosOpcionais ) &&
      !isEmptyObject( dadosOpcionais.cartao )
    ) {
      setDadosCartao( dadosOpcionais.cartao )
    }
  }, [ dadosOpcionais ] )

  const handleCVV = cvv => {
    setInfoPagamento( {
      ...infoPagamento,
      'cvv': cvv.numeroCVV,
      'forma_pagamento': METODO_PAGAMENTO_CARTAO.inicial,
      'id_cartao_credito': dadosCartao.id
    } )
  }

  function getAssinatura() {
    return modalidadesDaAssinatura[ 0 ] === 'Curadoria'
      ? `${MODALIDADE_CURADORIA.slug}/pagamento`
      : `${MODALIDADE_INEDITOS.slug}/pagamento `
  }

  if ( loadingOpcionais ) {
    return <InlineLoader isCenter />
  }

  if ( !isEmptyObject( dadosCartao ) && opcionaisSelecionados.length ) {
    return (
      <EstiloOpcionalCartao>
        <h3>Pagamento:</h3>

        <Wrapper>
          <p>{INFO_COMPRA_CARTAO_MODAL} </p>

          <CartaoCredito
            cartao={ dadosOpcionais.cartao }
            hover={ false }
            infoNumerica
            resumido
          />

          <div className="cvv-opcionais">
            <CVVInput handleCVV={ cvv => handleCVV( cvv ) } />
          </div>

          <ValorTotalOpcional />

          <BotaoOpcionais
            botaoCancelar={{
              ...BOTOES_CARTAO[ CANCELAR ],
              'acaoBotaoCancelar': () => fecharModal()
            }}
            botaoConfirmar={{
              ...BOTOES_CARTAO[ CONFIRMAR ],
              'acaoBotaoConfirmar': () => {
                comprarOpcional( modalidadesEscolhidaOpcionais.length &&
                    modalidadesEscolhidaOpcionais )
                setOpcionalSelecionado( [] )
              }
            }}
            modalidadesEscolhidaOpcionais={ modalidadesEscolhidaOpcionais }
          />
        </Wrapper>
      </EstiloOpcionalCartao>
    )
  }

  return (
    <Pmessage>
      {`Você ainda não possui um cartão cadastrado para efetuar a compra. `}

      <span onClick={ () => navigate( getAssinatura() ) }>Clique aqui</span>

      {` e cadastre seu pagamento.`}
    </Pmessage>
  )
}

OpcionaisPagamentoCartao.defaultProps = {
  'modalidadeEscolhida': null
}

OpcionaisPagamentoCartao.propTypes = {
  'fecharModal': func.isRequired,
  'modalidadeEscolhida': string,
  'modalidadesDaAssinatura': array.isRequired,
}

export default OpcionaisPagamentoCartao
